// BINDER configuration for Pagepilot (the editor panel).
// Storage prefix, cookie and handoff hash match the former built-in panel, so
// editors keep their position, view and preferences.

// All TYPO3 sites in display order. Key = URL prefix (or "cn" for binder-world.cn).
const MARKETS = [
    { key: 'int-en', label: 'English (Intl)', name: 'International · English' },
    { key: 'de-de', label: 'Deutsch', name: 'Germany · Deutsch' },
    { key: 'uk-en', label: 'English (UK)', name: 'United Kingdom · English' },
    { key: 'us-en', label: 'English (US)', name: 'USA · English' },
    { key: 'fr-fr', label: 'Français', name: 'France · Français' },
    { key: 'int-es', label: 'Español', name: 'International · Español' },
    { key: 'it-it', label: 'Italiano', name: 'Italy · Italiano' },
    { key: 'pl-pl', label: 'Polski', name: 'Poland · Polski' },
    { key: 'cn', label: '中文', name: 'China · 中文' }
];

const BCE_PREFIX = /^(bce|binder)[_-]/;

// BCE module name of an element (live or server HTML): the first bce_/binder_
// class that names a registered module.
function bceModuleOf(element) {
    const known = window.BCE?.getModules?.() || [];
    for (const className of element.classList) {
        if (!BCE_PREFIX.test(className)) continue;
        const name = className.replace(BCE_PREFIX, '');
        if (known.includes(name)) return name;
    }
    return null;
}

export default {
    title: 'Editor',
    // BINDER mark (three triangles, as in the logo)
    logo: '<svg viewBox="0 0 24 24"><path d="M4 2.5l8 4.6-8 4.6z M4 12.3l8 4.6-8 4.6z M12.6 7.4l8 4.6-8 4.6z" /></svg>',
    accent: '#e60000',
    accentSoft: '#ff4d4d',
    font: 'Inter, "Source Sans 3", system-ui, -apple-system, "Segoe UI", sans-serif',
    storagePrefix: 'bce_admin',

    // TYPO3 (site_binder backendUser.js) renders #hreflangLinks only for
    // logged-in backend users; the panel replaces that plain list.
    activation: { selector: '#hreflangLinks', timeout: 4000 },
    replaceSelector: '#hreflangLinks',
    ignoreSelectors: ['#binder-chatbot-root', '#hreflangLinks'],

    markets: MARKETS,
    marketFromUrl(url) {
        // binder-world.cn (live/stage) and binder-world-cn.test (local)
        if (/\.cn$/i.test(url.hostname) || /-cn\.test$/i.test(url.hostname)) return 'cn';
        return (url.pathname.split('/').filter(Boolean)[0] || '').toLowerCase();
    },

    environments: [
        [
            { label: 'Live', host: 'www.binder-world.com' },
            { label: 'Stage', host: 'stage.binder-world.com' },
            { label: 'Local', host: 'binder-world.test' }
        ],
        [
            { label: 'Live', host: 'www.binder-world.cn' },
            { label: 'Stage', host: 'stage.binder-world.cn' },
            { label: 'Local', host: 'binder-world-cn.test' }
        ]
    ],

    hideables: [
        { id: 'chatbot', label: 'Hide chat assistant', selector: '#binder-chatbot-root', icon: 'chat' }
    ],

    // binder-world.cn has no backend login; panel links carry editor mode there.
    handoffHash: '#bce-editor',
    noCacheParam: 'no_cache',
    contentIdPattern: /^c\d+$/,

    components: {
        label: 'BCE',
        selector: '[data-bce-processed]',
        rawSelector: '[class*="bce_"], [class*="bce-"], [class*="binder_"], [class*="binder-"]',
        nameOf: bceModuleOf,
        classPrefix: BCE_PREFIX,
        errorClass: 'bce-error'
    }
};
